import React from 'react';
import { formatDataPtBR } from '../../utils/dateFormat';

/**
 * Bloco final do PDF: linhas de assinatura + rodapé.
 *
 * Hotfix TD53: rodapé reformulado pra texto cliente-facing posicionando o
 * Tenant como dono do conteúdo (e Qaa.sa como plataforma analítica de apoio).
 * Antes: "Este documento foi gerado por Qaa.sa em ..." — soava como output
 * de máquina sem responsável humano.
 *
 * Recebe `empresa` (= reportData.empresa) pra extrair o nome do tenant.
 * Quando empresa não tem nome (raro — só se backend não enviar), cai em
 * fallback que omite a parte "validado pela equipe técnica da X" pra não
 * gerar frase quebrada com placeholder.
 */
export default function PrintableSignatures({ empresa = {} }) {
  const tenantNome = empresa.nome_fantasia || empresa.razao_social || '—';
  const dataHoje = formatDataPtBR(new Date());

  return (
    <section className="printable-signatures">
      <div className="signatures-divider"></div>
      <h3 className="signatures-title">ASSINATURAS</h3>

      <div className="signatures-grid">
        <div className="signature-block">
          <div className="signature-line"></div>
          <div className="signature-role">Responsável Técnico</div>
          <div className="signature-meta">Nome / Data</div>
        </div>
        <div className="signature-block">
          <div className="signature-line"></div>
          <div className="signature-role">Aprovação Qualidade</div>
          <div className="signature-meta">Nome / Data</div>
        </div>
      </div>

      <div className="signatures-footer">
        <p>
          {tenantNome !== '—' ? (
            <>
              Relatório elaborado com apoio analítico da plataforma Qaa.sa e validado pela equipe técnica da <strong>{tenantNome}</strong> em {dataHoje}.
            </>
          ) : (
            <>
              Relatório elaborado com apoio analítico da plataforma Qaa.sa em {dataHoje}.
            </>
          )}
        </p>
        <p style={{ marginTop: '6px' }}>
          Gerencie suas Não Conformidades na plataforma Qaa.sa:{' '}
          <a href="https://qaasa.com.br" target="_blank" rel="noopener noreferrer">
            qaasa.com.br
          </a>
        </p>
      </div>
    </section>
  );
}
